import React from 'react';
import {
    FaMountainCity,
    FaArrowUpFromGroundWater,
    FaCompassDrafting,
    FaTrowelBricks,
    FaHelmetSafety,
} from 'react-icons/fa6';
import { BiCheckShield } from 'react-icons/bi';
import { BsArrowRight, BsBrightnessAltHigh, BsFileEasel } from 'react-icons/bs';
import mainImg from "../assets/img/alt-services.jpg";
import { useTranslation } from 'react-i18next';

const Services = () => {
    const { t } = useTranslation();

    // Dynamic services data - now using translations
    const services = [
        {
            id: 1,
            icon: <FaMountainCity />,
            title: t('key-company-services.items.1.title'),
            description: t('key-company-services.items.1.description'),
            delay: 100,
        },
        {
            id: 2,
            icon: <FaArrowUpFromGroundWater />,
            title: t('key-company-services.items.2.title'),
            description: t('key-company-services.items.2.description'),
            delay: 200,
        },
        {
            id: 3,
            icon: <FaCompassDrafting />,
            title: t('key-company-services.items.3.title'),
            description: t('key-company-services.items.3.description'),
            delay: 300,
        },
    ];

    // Dynamic icon boxes - now using translations
    const iconBoxes = [
        {
            id: 1,
            icon: <BsFileEasel className="flex-shrink-0" />,
            title: t('key-company-services.alt.boxes.1.title'),
            link: '#',
            description: t('key-company-services.alt.boxes.1.description'),
            delay: 300,
        },
        {
            id: 2,
            icon: <BiCheckShield className="flex-shrink-0" />,
            title: t('key-company-services.alt.boxes.2.title'),
            link: '#',
            description: t('key-company-services.alt.boxes.2.description'),
            delay: 400,
        },
        {
            id: 3,
            icon: <BsBrightnessAltHigh className="flex-shrink-0" />,
            title: t('key-company-services.alt.boxes.3.title'),
            link: '#',
            description: t('key-company-services.alt.boxes.3.description'),
            delay: 500,
        },
        {
            id: 4,
            icon: <BsBrightnessAltHigh className="flex-shrink-0" />,
            title: t('key-company-services.alt.boxes.4.title'),
            link: '#',
            description: t('key-company-services.alt.boxes.4.description'),
            delay: 600,
        },
    ];

    return (
        <>
            {/* Services Section */}
            <section id="services" className="services section light-background">
                {/* Section Title */}
                <div className="container">
                    <div className="row gy-4">
                        {services.map(({ id, icon, title, description, delay }) => (
                            <div
                                key={id}
                                className="col-lg-4 col-md-6"
                                data-aos="fade-up"
                                data-aos-delay={delay}
                            >
                                <div className="service-item position-relative">
                                    <div className="icon">{icon}</div>
                                    <h3>{title}</h3>
                                    <p>{description}</p>
                                    <a href="#" className="readmore stretched-link">
                                        {t('key-company-services.readMore')} <BsArrowRight />
                                    </a>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Alt Services Section */}
            {/* <section id="alt-services" className="alt-services section">
                <div className="container">
                    <div className="row justify-content-around gy-4">
                        <div
                            className="features-image col-lg-6"
                            data-aos="fade-up"
                            data-aos-delay={iconBoxes[0].delay - 200}
                        >
                            <img src={mainImg} alt="" />
                        </div>

                        <div
                            className="col-lg-5 d-flex flex-column justify-content-center"
                            data-aos="fade-up"
                            data-aos-delay={200}
                        >
                            <h3>{t('services.alt.heading')}</h3>
                            <p>{t('services.alt.desc')}</p>

                            {iconBoxes.map(({ id, icon, title, link, description, delay }) => (
                                <div
                                    key={id}
                                    className="icon-box d-flex position-relative"
                                    data-aos="fade-up"
                                    data-aos-delay={delay}
                                >
                                    {icon}
                                    <div>
                                        <h4>
                                            <a href={link} className="stretched-link">
                                                {title}
                                            </a>
                                        </h4>
                                        <p>{description}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </section> */}
        </>
    );
};

export default Services;